import slideOne from "../img/1.webp";
import slideTwo from "../img/2.webp";
import slideThree from "../img/3.webp";
import slideFour from "../img/4.webp";
import ImgRezerwacjaWyslana from "../img/Img_rezerwacja_wyslana.jpg";
import menuItems from "../constants/menuItems";
import Navbar from "../components/Navbar";
import ReservationClient from "./ReservationClient";

const SLIDES = [slideOne, slideTwo, slideThree, slideFour];

function HomePageClient({ onLogout, userRole }) {
    return (
        <>
            <main className="ClientShell">
                <div className="ClientNavWrap">
                    <Navbar
                        menuItems={menuItems}
                        onLogout={onLogout}
                        userRole={userRole}
                    />
                </div>

                <div style={{ textAlign: "center", marginBottom: 1 }}>
                    <img src={ImgRezerwacjaWyslana} alt="Rezerwacja wysłana" style={{ maxWidth: "100%", height: "auto" }} />
                </div>
                <ReservationClient />

                {/* <section className="ClientHero">
                    
                    
                    <div className="ClientSlider" aria-label="Galeria schroniska">
                        {SLIDES.map((src, index) => (
                            <div
                                key={src}
                                className="ClientSlide"
                                style={{
                                    "--slide-left": `${index * 160}px`,
                                    "--slide-z": index + 1
                                }}
                            >
                                <img src={src} alt="" className="ClientSlideImage" />
                            </div>
                        ))}
                    </div>
                    <div className="ClientReservationRow">
                        <ReservationClient />
                    </div>
                </section> */}

            </main>
        </>
    );
}

export default HomePageClient;
